{
  "familyId": "SPR-SAM-TUSSEN-N",
  "questions": [
    {
      "id": "SPR-SAM-TUSSEN-N-001",
      "familyId": "SPR-SAM-TUSSEN-N",
      "module": "SpellingRegel",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "samenstelling",
      "subSkill": "samenst_tussen_n",
      "questionType": "multiple_choice",
      "question": "Welke spelling is correct?",
      "options": ["pannenkoek", "pannekoek", "pankoek", "pannnenkoek"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {"type": "rule", "showWhen": "wrong", "data": {"title": "Tussen-n regel", "content": "Bij samenstellingen met een meervoud op -en schrijf je een tussen-n.\n\npan → pannen (meervoud op -en)\npannen + koek = pannenkoek\n\nDe tussen-n komt van het meervoud. Denk: meerdere pannen → pannenkoek.", "icon": "book"}}
      ],
      "conceptId": "linking_n_pannenkoek",
      "variantIndex": 1,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Het eerste deel is 'pan'. Het meervoud van pan is 'pannen' (eindigt op -en). Bij samenstellingen gebruik je het meervoud: pannen + koek = pannenkoek. De tussen-n komt van het meervoud op -en.",
        "solutionSteps": [
          "Bepaal het eerste deel: pan",
          "Maak het meervoud: pan → pannen (-en)",
          "Meervoud op -en → tussen-n in de samenstelling",
          "pannen + koek = pannenkoek ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! Pan → pannen → pannenkoek. De tussen-n komt van het meervoud.",
          "1": "Je bent de n vergeten. Het meervoud van 'pan' is 'pannen' (met n). Dus: pannenkoek, niet pannekoek.",
          "2": "Je hebt het eerste deel in het enkelvoud geschreven. Bij samenstellingen met een meervoud op -en gebruik je het meervoud: pannen + koek = pannenkoek.",
          "3": "Je hebt drie n's geschreven. Dat is te veel. Het meervoud is 'pannen' (twee n's) + koek = pannenkoek."
        }
      }
    },
    {
      "id": "SPR-SAM-TUSSEN-N-002",
      "familyId": "SPR-SAM-TUSSEN-N",
      "module": "SpellingRegel",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "samenstelling",
      "subSkill": "samenst_tussen_n",
      "questionType": "multiple_choice",
      "question": "Welk woord is correct geschreven?",
      "options": ["zonbloem", "zonenbloem", "zonnenbloem", "zonnebloem"],
      "correctAnswer": 3,
      "stimulusAids": [],
      "supportAids": [
        {"type": "rule", "showWhen": "wrong", "data": {"title": "Tussen-n bij 'zon'", "content": "Zon → zonnen (meervoud op -en).\nMaar let op: bij 'zonnebloem' valt de laatste -n weg!\n\nDit is een uitzondering. Bij sommige woorden schrijf je -e in plaats van -en:\nzonnebloem, zonneschijn, zonnestraal.", "icon": "book"}}
      ],
      "conceptId": "linking_n_zonnebloem",
      "variantIndex": 2,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Bij 'zonnebloem' schrijf je een tussen-e, niet een tussen-en. Dit is een uitzondering op de tussen-n regel. Het meervoud van 'zon' is 'zonnen', maar in de samenstelling valt de -n weg: zonne + bloem = zonnebloem. Andere voorbeelden: zonneschijn, zonnestraal.",
        "solutionSteps": [
          "Eerste deel: zon → meervoud: zonnen",
          "In de samenstelling valt de -n weg: zonne-",
          "zonne + bloem = zonnebloem",
          "Dit is een uitzondering — onthoud het!"
        ],
        "distractorExplanations": {
          "0": "Je hebt geen verbindingsklank gebruikt. 'Zonbloem' klinkt niet goed. Het is 'zonnebloem'.",
          "1": "'Zonenbloem' heeft maar één n. Het meervoud van zon is 'zonnen' (dubbele n), maar de -n valt weg: zonnebloem.",
          "2": "'Zonnenbloem' heeft de volledige -en. Maar bij dit woord valt de -n weg: zonnebloem, niet zonnenbloem.",
          "3": "Goed! Zonnebloem — met tussen-e (de -n valt weg)."
        }
      }
    },
    {
      "id": "SPR-SAM-TUSSEN-N-003",
      "familyId": "SPR-SAM-TUSSEN-N",
      "module": "SpellingRegel",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "samenstelling",
      "subSkill": "samenst_tussen_n",
      "questionType": "multiple_choice",
      "question": "Welke samenstelling heeft een tussen-n (de -en van het meervoud)?",
      "options": ["zonnebloem", "dorpsplein", "ruggengraat", "landbouwgrond"],
      "correctAnswer": 2,
      "stimulusAids": [],
      "supportAids": [
        {"type": "rule", "showWhen": "wrong", "data": {"title": "Tussen-n herkennen", "content": "Een tussen-n komt van het meervoud op -en:\nrug → ruggen → ruggengraat (tussen-n)\n\nLet op het verschil:\n- Tussen-n (meervoud -en): ruggengraat, pannenkoek, boekenplank\n- Tussen-e (n valt weg): zonnebloem, zonneschijn\n- Tussen-s: dorpsplein, stadsmuur", "icon": "book"}}
      ],
      "conceptId": "linking_n_herkennen",
      "variantIndex": 3,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Ruggengraat heeft een tussen-n. Rug → ruggen (meervoud op -en) → ruggengraat. De andere woorden hebben andere verbindingsklanken: zonnebloem (tussen-e), dorpsplein (tussen-s), landbouwgrond (geen verbindingsklank).",
        "solutionSteps": [
          "Ruggengraat: rug → ruggen (-en) → tussen-n ✓",
          "Zonnebloem: zon → zonne- (tussen-e, n valt weg)",
          "Dorpsplein: dorp + s (tussen-s)",
          "Landbouwgrond: landbouw + grond (geen verbindingsklank)"
        ],
        "distractorExplanations": {
          "0": "Zonnebloem heeft een tussen-e, niet een tussen-n. De -n van het meervoud valt hier weg: zonne + bloem.",
          "1": "Dorpsplein heeft een tussen-s, niet een tussen-n. Dorp + s + plein = dorpsplein.",
          "2": "Goed! Rug → ruggen → ruggengraat. De -en van het meervoud is de tussen-n.",
          "3": "Landbouwgrond heeft geen verbindingsklank. Landbouw + grond = landbouwgrond."
        }
      }
    },
    {
      "id": "SPR-SAM-TUSSEN-N-004",
      "familyId": "SPR-SAM-TUSSEN-N",
      "module": "SpellingRegel",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "samenstelling",
      "subSkill": "samenst_tussen_n",
      "questionType": "multiple_choice",
      "question": "Welke spelling is correct?",
      "options": ["boekeplank", "boekenplank", "boekplank", "boekensplank"],
      "correctAnswer": 1,
      "stimulusAids": [],
      "supportAids": [
        {"type": "rule", "showWhen": "wrong", "data": {"title": "Boeken + plank", "content": "Boek → boeken (meervoud op -en).\nboeken + plank = boekenplank.\n\nDe tussen-n komt van het meervoud. Andere voorbeelden: boekenkast, boekentas, boekenrek.", "icon": "book"}}
      ],
      "conceptId": "linking_n_boekenplank",
      "variantIndex": 4,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Boek → boeken (meervoud op -en). In de samenstelling gebruik je het meervoud: boeken + plank = boekenplank. Andere voorbeelden: boekenkast, boekentas.",
        "solutionSteps": [
          "Eerste deel: boek",
          "Meervoud: boek → boeken (-en)",
          "Samenstelling: boeken + plank = boekenplank"
        ],
        "distractorExplanations": {
          "0": "'Boekeplank' mist de n. Het meervoud is 'boeken' (met n): boekenplank.",
          "1": "Goed! Boek → boeken → boekenplank.",
          "2": "'Boekplank' heeft geen verbindingsklank. Je hebt het meervoud nodig: boeken + plank.",
          "3": "'Boekensplank' heeft een extra s. Er is geen tussen-s nodig: boeken + plank = boekenplank."
        }
      }
    },
    {
      "id": "SPR-SAM-TUSSEN-N-005",
      "familyId": "SPR-SAM-TUSSEN-N",
      "module": "SpellingRegel",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "samenstelling",
      "subSkill": "samenst_tussen_n",
      "questionType": "fill_in",
      "question": "Maak een samenstelling van 'fiets' en 'rek'. Typ het hele woord.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["fietsenrek"],
        "caseSensitive": false,
        "placeholder": "typ het woord"
      },
      "stimulusAids": [],
      "supportAids": [
        {"type": "rule", "showWhen": "wrong", "data": {"title": "Fietsen + rek", "content": "Fiets → fietsen (meervoud op -en).\nfietsen + rek = fietsenrek.\n\nDe tussen-n komt van het meervoud. Spreek het uit: fietsen-rek.", "icon": "book"}}
      ],
      "conceptId": "linking_n_fill",
      "variantIndex": 5,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Fiets → fietsen (meervoud op -en). In de samenstelling gebruik je het meervoud: fietsen + rek = fietsenrek. Spreek het uit: je hoort 'fietsen-rek'.",
        "solutionSteps": [
          "Eerste deel: fiets",
          "Meervoud: fiets → fietsen (-en)",
          "Samenstelling: fietsen + rek = fietsenrek"
        ]
      }
    },
    {
      "id": "SPR-SAM-TUSSEN-N-006",
      "familyId": "SPR-SAM-TUSSEN-N",
      "module": "SpellingRegel",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "samenstelling",
      "subSkill": "samenst_tussen_n",
      "questionType": "error_spotting",
      "question": "Zoek de spelfout in de zin en verbeter het woord.",
      "data": {
        "text": "Mijn moeder zette de bloemen in een bloemevase op de tafel.",
        "errors": [
          {
            "word": "bloemevase",
            "position": 9,
            "correction": "bloemenvaas",
            "explanation": "Bloem → bloemen (meervoud op -en). De samenstelling is bloemen + vaas = bloemenvaas. Let ook op: 'vaas' (met dubbele a), niet 'vase'."
          }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {"type": "rule", "showWhen": "wrong", "data": {"title": "Tussen-n in samenstellingen", "content": "Bij samenstellingen met een meervoud op -en schrijf je de volledige meervoudsvorm:\nbloem → bloemen → bloemenvaas\n\nDe tussen-n komt van het meervoud. Spreek het uit: bloemen-vaas.", "icon": "book"}}
      ],
      "conceptId": "linking_n_error_spotting",
      "variantIndex": 6,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "'Bloemevase' bevat twee fouten: de tussen-n ontbreekt (bloeme → bloemen) en 'vaas' is fout gespeld (vase → vaas). De samenstelling is: bloem → bloemen (meervoud op -en) + vaas = bloemenvaas. De tussen-n komt van het meervoud. Andere voorbeelden: boekenplank, pannenkoek, fietsenrek.",
        "solutionSteps": [
          "Lees de zin en zoek het woord dat er niet goed uitziet",
          "'Bloemevase' — klopt de verbindingsklank? Nee, de -n ontbreekt",
          "Bloem → bloemen (meervoud op -en) → tussen-n nodig",
          "Verbetering: bloemenvaas (bloemen + vaas)"
        ]
      }
    },
    {
      "id": "SPR-SAM-TUSSEN-N-007",
      "familyId": "SPR-SAM-TUSSEN-N",
      "module": "SpellingRegel",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "samenstelling",
      "subSkill": "samenst_tussen_n",
      "questionType": "categorize",
      "question": "Sorteer deze samenstellingen: welke hebben een tussen-n (-en) en welke hebben een tussen-e (-n valt weg)?",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "categories": ["Tussen-n (meervoud -en)", "Tussen-e (n valt weg)"],
        "items": [
          {"text": "pannenkoek", "correctCategory": 0},
          {"text": "zonnebloem", "correctCategory": 1},
          {"text": "boekenplank", "correctCategory": 0},
          {"text": "zonnestraal", "correctCategory": 1},
          {"text": "fietsenrek", "correctCategory": 0},
          {"text": "zonneschijn", "correctCategory": 1}
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {"type": "rule", "showWhen": "wrong", "data": {"title": "Tussen-n vs. tussen-e", "content": "De meeste samenstellingen met een meervoud op -en krijgen een tussen-n:\npannenkoek, boekenplank, fietsenrek.\n\nMaar bij woorden met 'zon' valt de -n weg:\nzonnebloem, zonnestraal, zonneschijn.\n\nDit is een uitzondering die je moet onthouden.", "icon": "book"}}
      ],
      "conceptId": "linking_n_categorize",
      "variantIndex": 7,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.69,
      "feedback": {
        "explanationText": "Tussen-n (volledige meervoud -en): pannenkoek (pan → pannen), boekenplank (boek → boeken), fietsenrek (fiets → fietsen). Tussen-e (de -n valt weg): zonnebloem, zonnestraal, zonneschijn — allemaal met 'zon'. Bij 'zon'-samenstellingen is de tussen-e een uitzondering die je moet onthouden.",
        "solutionSteps": [
          "Pannenkoek: pan → pannen → tussen-n ✓",
          "Zonnebloem: zon → zonne- (n valt weg) → tussen-e",
          "Boekenplank: boek → boeken → tussen-n ✓",
          "Zonnestraal: zon → zonne- → tussen-e",
          "Fietsenrek: fiets → fietsen → tussen-n ✓",
          "Zonneschijn: zon → zonne- → tussen-e"
        ]
      }
    },
    {
      "id": "SPR-SAM-TUSSEN-N-008",
      "familyId": "SPR-SAM-TUSSEN-N",
      "module": "SpellingRegel",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "samenstelling",
      "subSkill": "samenst_tussen_n",
      "questionType": "fill_in",
      "question": "Maak een samenstelling van 'koek' en 'pan'. Typ het hele woord.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["koekenpan", "koekepan"],
        "caseSensitive": false,
        "placeholder": "typ het woord"
      },
      "stimulusAids": [],
      "supportAids": [
        {"type": "rule", "showWhen": "wrong", "data": {"title": "Koeken + pan", "content": "Koek → koeken (meervoud op -en).\nkoeken + pan = koekenpan.\n\nDe tussen-n komt van het meervoud. Spreek het uit: koeken-pan. Let op: 'koekepan' (zonder n) wordt ook geaccepteerd — beide vormen komen voor.", "icon": "book"}}
      ],
      "conceptId": "linking_n_fill_koekenpan",
      "variantIndex": 8,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Koek → koeken (meervoud op -en). In de samenstelling gebruik je het meervoud: koeken + pan = koekenpan. Spreek het uit: je hoort 'koeken-pan'. Let op: 'koekepan' (zonder n) wordt ook geaccepteerd — in sommige woordenboeken staan beide vormen. De standaardvorm is 'koekenpan'.",
        "solutionSteps": [
          "Eerste deel: koek",
          "Meervoud: koek → koeken (-en)",
          "Samenstelling: koeken + pan = koekenpan"
        ]
      }
    }
  ]
}